// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import { sendUploadUrl } from '../../services/orbitzService';
import './insurance-upload.scss';
import AuthService from '../../services/authService';
import userService from '../../services/userService';
import FormikControl from '../Formik/FormikControl';
import { toast } from 'react-toastify';
import { useHistory, useLocation } from 'react-router-dom';

interface Props {
  onOpenManual?: () => void;
  openedFromModal?: boolean;
  uploadOnly?: boolean;
  userId?: string;
  selectedInsurance?: string;
  onConfirm?: (values, loading) => void;
  setFormikState?: any;
  onSend: () => void;
  onExitEditMode?: () => void;
  onStartPolling?: () => void; 
}

const InsuranceUpload = ({
  onOpenManual,
  openedFromModal,
  selectedInsurance,
  onConfirm,
  setFormikState,
  onSend,
  onExitEditMode,
  onStartPolling,
}: Props) => {
  const { user } = AuthService.getAuth();
  const [loadingState, setLoadingState] = useState({
    uploadingPhotoRequest: false,
    mobileRequest: false,
    confirmingImagesRequest: false,
    uploadOnlySuccess: false,
  });
  const [phone, setPhone] = useState(user?.phone || '');
  const [verificationCode, setVerificationCode] = useState('');
  const history = useHistory();
  const location = useLocation();
  const { pathname } = location;

  if (
    !openedFromModal &&
    (/iPhone/i.test(navigator.userAgent) || /Android/i.test(navigator.userAgent))
  ) {
    history.push(
      `/upload-insurance?v=1${
        ['/registration', '/complete-profile'].includes(pathname) ? '&r=1' : ''
      }`
    );
  }  

  const handleOnOpenManual = () => {
    if (onOpenManual) onOpenManual(setFormikState);
  };

  const handleSendUrl = async () => {
    try {
      if (onSend) await onSend();
      console.log("SMS selectedInsurance:", selectedInsurance);

      if (!selectedInsurance || !selectedInsurance._id) {
        toast.error("Insurance card is not ready. Please try again.");
        return;
      }
      await sendUploadUrl(selectedInsurance._id, phone, user?.id, window.location.origin);
      const response = await userService.sendVerificationCode(
        user?.email,
        'uploadInsurance',
        'direct'
      );

      if (onStartPolling) {
        setTimeout(() => onStartPolling(), 0);
      }

      if (onExitEditMode) onExitEditMode();
    
      const { data } = response;
      const { verificationCodeValue } = data;
      setVerificationCode(verificationCodeValue);
      setLoadingState((prevState) => ({
        ...prevState,
        mobileRequest: true,
      }));
    } catch (err) {
      toast.error(
        'We were unable to send you a link to upload your insurance card. Please try again. ',
      );
    }
  };

  // Updating inputs
  const handlePhoneChange = (e: any) => {
    setPhone(e.value);
  };

  return (
    <div className="insurance-upload">
      {loadingState.uploadOnlySuccess ? (
        <>
          <p className="--bold">Successfully uploaded!</p>
          <p>Please return to the insurance info page you left open.</p>
        </>
      ) : (
        <>
          {!loadingState.mobileRequest ? (
            <>
              <p> </p>
              <p className="center-text">
                Confirm your phone number to receive a text message link
                allowing you to take a photo of your insurance card
              </p>
              <div className="flex-box --input">
                <FormikControl
                  className="phone"
                  control="input"
                  type="text"
                  name="phone"
                  maxLength={15}
                  placeholder="Phone Number"
                  format="(###) ###-####"
                  value={phone}
                  onChange={handlePhoneChange}
                  showErrorMsg={false}
                />
                <Button
                  variant="contained"
                  onClick={handleSendUrl}
                  >
                  Send
                </Button>
              </div>
            </>
          ) : (
            <div className="flex-box">
              <p style={{ fontSize: '1rem' }}>
                Use this code in the link sent to the number you provided:
              </p>
              <p style={{ fontSize: '2rem', margin: '1rem auto 1rem' }}>
                {verificationCode}
              </p>
            </div>
          )}

          { !openedFromModal && <>
            <p className="insurance-upload_open-manual mt-3 mb-3">
            Having trouble providing photos of your card?
            </p>
            <button
              type="button"
              onClick={handleOnOpenManual}
              className="text-btn  --link">
              Enter Insurance Details Manually
            </button>
          </>}
        </>
      )}
    </div>
  );
};

export default InsuranceUpload;
